var exports = {
  "O": "danger__YMEsWg",
  "a": "subtle__BOVDmu",
};

module.exports = exports;
